




























import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import * as routes from "@/employer/route-names";

@Component
export default class CommunicationNavigation extends Vue {
  routes = routes;
  activeTab = null;

  @Prop()
  accountHolderRoute: string;

  @Prop()
  employerRoute: string;

  mounted (): void {
    this.activeTab = this.$route.name;
  }

  navigationClicked (pathName: string) {
    this.activeTab = pathName;
    this.$emit("navigation-tab-item-clicked", {
      name: this.$route.name,
      path: pathName
    });
  }
}
